import { render } from "./RestaurantLayout.vue?vue&type=template&id=bb67c052"
const script = {}

import exportComponent from "../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__